import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useContext, useMemo, useState } from "react";
import { Check } from "react-feather";
import { useTranslation } from "react-i18next";
import { Badge, Card, CardBody } from "reactstrap";
import { UserContext } from "../../../Context/UserContext";
import { apiWrapper } from "../../../utils/Functions/apiWrapper";
import CardMaintenanceModal from "../../CardMaintenanceModal";
import InstaPayLoader from "../../Loader";
import bd from "../../PaymentsNewer/files/bd.png";
import i from "../../PaymentsNewer/files/i.svg";
import mw from "../../PaymentsNewer/files/mw.png";
import pc from "../../PaymentsNewer/files/pc.png";
import TypingSpan from "../../TypingSpan";

const Channels = ({ setChannel, channel, thunesServices, thunesProviders = [] }) => {
  const { t } = useTranslation();
  const { userDetails } = useContext(UserContext);
  const [showCardMaintenanceModal, setShowCardMaintenanceModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const { data: methods, isLoading } = useQuery({
    queryKey: ["AvailableMethods"],
    queryFn: () =>
      apiWrapper({
        endpoint: `/api/payment/get-available-methods/${userDetails?._id}/${userDetails?.country_iso_code}`,
      }).then((dec) => dec?.data),
    retry: 3,
  });
  const payoutChannelData = [
    userDetails?.level?.topup_channel?.card_payment
      ? {
          name: "Payment Card",
          id: 5,
          icon: pc,
          value: "card",
          coming_soon: userDetails?.level?.topup_channel?.card_payment === "coming_soon",
        }
      : {},
    userDetails?.level?.topup_channel?.paypal
      ? {
          name: "Paypal",
          id: 5,
          icon: pc,
          value: "paypal",
          coming_soon: userDetails?.level?.topup_channel?.paypal === "coming_soon",
        }
      : {},
    userDetails?.level?.topup_channel?.bank_deposit
      ? {
          name: "Bank Deposit",
          id: 2,
          icon: bd,
          value: "bank",
          coming_soon: userDetails?.level?.topup_channel?.bank_deposit === "coming_soon",
        }
      : {},
    userDetails?.level?.topup_channel?.bank
      ? {
          name: "Bank Transfer (Europe)",
          id: 6,
          icon: bd,
          value: "bank_transfer",
          api_val: "bank",
          coming_soon: false,
        }
      : {},
    userDetails?.level?.topup_channel?.crypto
      ? {
          name: "Crypto Transfer",
          id: 2,
          icon: bd,
          value: "crypto",
          coming_soon: userDetails?.level?.topup_channel?.crypto === "coming_soon",
        }
      : {},
  ];

  const thunesAllowed = [
    userDetails?.level?.topup_channel?.mobile_money
      ? {
          name: "Mobile Wallet",
          id: 1,
          icon: mw,
          value: "mobile_wallet",
          // coming_soon: userDetails?.level?.topup_channel?.mobile_money === "coming_soon",
          sub_name: "wallet",
        }
      : {},
  ];

  const filteredChannels = useMemo(() => {
    const allChannels = [...thunesAllowed, ...payoutChannelData].filter((item) => item?.name);

    if (!methods || isLoading) return allChannels;

    return allChannels.filter(
      (item) => methods?.includes(item.value) || methods?.includes(item.api_val),
    );
  }, [payoutChannelData, thunesAllowed, methods, isLoading]);
  return (
    <>
      <CardMaintenanceModal
        isOpen={showCardMaintenanceModal}
        toggle={() => setShowCardMaintenanceModal(false)}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          maxHeight: "550px",
          overflowY: "auto",
        }}
      >
        {!isLoading ? (
          filteredChannels.map((item) => (
            <Card
              key={item?.name}
              style={{ marginBottom: 0, borderRadius: "12px" }}
              onClick={() => {
                if (item?.coming_soon) return;
                if (item?.value === "crypto") {
                  const isApproved =
                    userDetails?.account_type === "individual"
                      ? userDetails?.user?.kyc_status === "approved"
                      : userDetails?.company?.kyb_status === "approved";

                  if (!isApproved) {
                    setShowVerificationModal(true);
                    return;
                  }
                }
                if (item?.value === "card") {
                  setShowCardMaintenanceModal(true);
                  return;
                }
                setChannel(item);
              }}
            >
              <CardBody
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: ".5rem",
                  padding: "15px",
                  justifyContent: "space-between",
                  cursor: item?.coming_soon ? "not-allowed" : "pointer",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      height: "35px",
                      width: "35px",
                      background:
                        "linear-gradient(-24deg, rgb(210, 60, 122) 0%, rgb(164, 52, 167) 43.66%, rgb(88, 38, 239) 100%)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "12px",
                      boxShadow: "0px 4px 7px rgba(172, 53, 159, 0.31)",
                    }}
                  >
                    <img
                      src={item?.icon}
                      draggable="false"
                      alt={item?.name?.[0]}
                      style={{
                        width: "19px",
                        objectFit: "contain",
                        aspectRatio: 1,
                      }}
                    />
                  </div>
                  <h5 style={{ marginBottom: 0, fontSize: "1.2rem" }}>
                    {t(item?.name) + " "}
                    {window.innerWidth < 1000 && <br />}
                    {thunesProviders?.length > 0 && item?.sub_name === "wallet" ? (
                      <>
                        (
                        <TypingSpan words={thunesProviders.map((item) => item?.name ?? "")} />)
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                </div>
                {item?.coming_soon ? (
                  <Badge color="primary">{t("Coming Soon")}</Badge>
                ) : channel?.name === item?.name ? (
                  <Check color="green" size={24} style={{ position: "absolute", right: "20px" }} />
                ) : (
                  <img
                    src={i}
                    alt="i"
                    style={{
                      objectFit: "cover",
                      position: "absolute",
                      right: "14px",
                      top: "19px",
                    }}
                  />
                )}
              </CardBody>
            </Card>
          ))
        ) : (
          <>
            <InstaPayLoader />
          </>
        )}
        <Dialog
          open={showVerificationModal}
          onClose={() => setShowVerificationModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>{t("Verification Required")}</DialogTitle>

          <DialogContent>
            {t("Please complete and get your KYC and KYB approved before using Crypto Transfer.")}
          </DialogContent>

          <DialogActions>
            <button
              onClick={() => setShowVerificationModal(false)}
              style={{
                backgroundColor: "#5926f0",
                color: "white",
                borderRadius: "8px",
                border: "none",
                padding: "8px 16px",
                margin: "8px",
                "&:hover": {
                  backgroundColor: "#5926f0",
                },
              }}
            >
              {t("OK")}
            </button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Channels;
